import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HistorySectionRefreshEvent } from 'src/app/models/events/history-section-refresh-event';

@Injectable({
    providedIn: 'root',
})
export class HistorySectionEventsService {
    /**
     * Emis lorsque la section doit être rechargée.
     * Paramètre : Id du dossier.
     */
    public needRefresh = new Subject<HistorySectionRefreshEvent>();
}
